var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 2860306"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 2860369"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 2860375"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 164",
    filter: "url(#filter0_d_4701_26111)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 6,
    width: 36,
    height: 36,
    rx: 18,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.0208 30.8947C31.021 31.4259 30.8291 31.9374 30.4836 32.3269C30.1382 32.7163 29.6647 32.9549 29.158 32.9947L29.007 33H26.9932C26.4851 33.0002 25.9958 32.7996 25.6232 32.4384C25.2507 32.0773 25.0225 31.5823 24.9844 31.0526L24.9794 30.8947H31.0208ZM28.0001 13C29.8276 13 31.5837 13.742 32.8979 15.0696C34.2121 16.3971 34.9818 18.2064 35.0444 20.1158L35.0484 20.3684V24.3305L36.883 28.1663C36.9631 28.3337 37.0032 28.5188 36.9998 28.7059C36.9964 28.893 36.9498 29.0765 36.8637 29.2406C36.7777 29.4047 36.655 29.5446 36.5059 29.6482C36.3569 29.7519 36.186 29.8163 36.008 29.8358L35.8922 29.8421H20.1079C19.9289 29.8422 19.7525 29.7968 19.5938 29.71C19.4352 29.6232 19.2991 29.4974 19.1971 29.3435C19.0951 29.1896 19.0304 29.0122 19.0084 28.8264C18.9864 28.6407 19.0078 28.4521 19.0708 28.2768L19.1171 28.1663L20.9517 24.3305V20.3684C20.9517 18.4142 21.6943 16.54 23.0161 15.1582C24.338 13.7763 26.1307 13 28.0001 13ZM28.0001 15.1053C26.7027 15.1053 25.4555 15.629 24.5184 16.567C23.5814 17.505 23.0269 18.785 22.9706 20.14L22.9655 20.3684V24.3305C22.9655 24.5916 22.9191 24.8504 22.8286 25.0937L22.7531 25.2726L21.575 27.7368H34.4262L33.2481 25.2716C33.1363 25.0382 33.067 24.7851 33.0437 24.5253L33.0346 24.3305V20.3684C33.0346 18.9725 32.5042 17.6338 31.56 16.6468C30.6159 15.6598 29.3353 15.1053 28.0001 15.1053Z",
    fill: "black"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4701_26111",
    x: 0,
    y: 0,
    width: 56,
    height: 56,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.604167 0 0 0 0 0.604167 0 0 0 0 0.604167 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4701_26111"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4701_26111",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.488d0fc6ca076134827709e616b42b57.svg";
export { ForwardRef as ReactComponent };